import { RawTradingAnalytics, TradingAnalytics } from '../../../model/tradingAnalytics';
import { parseDateTime, RawDateTimes } from '../../parse';
import { TRADING_ACTIVITY_SUMMARY_ROWS_ORDER } from './tradingActivity.mapper.constants';

export function fromServerMap(tradingAnalytics: RawDateTimes<RawTradingAnalytics>): TradingAnalytics {
  return {
    ...tradingAnalytics,
    summary: Object.entries(tradingAnalytics.summary)
      .map(([key, value]) => ({
        ...value,
        metricName: key,
      }))
      .sort(
        (a, b) =>
          TRADING_ACTIVITY_SUMMARY_ROWS_ORDER.indexOf(a.metricName.toUpperCase()) -
          TRADING_ACTIVITY_SUMMARY_ROWS_ORDER.indexOf(b.metricName.toUpperCase()),
      ),
    longCompanies: tradingAnalytics.longCompanies.map((company) => ({
      ...company,
      company: {
        id: company.companyId,
        ticker: company.ticker,
        name: company.companyName,
      },
    })),
    shortCompanies: tradingAnalytics.shortCompanies.map((company) => ({
      ...company,
      company: {
        id: company.companyId,
        ticker: company.ticker,
        name: company.companyName,
      },
    })),
    lastUpdated: parseDateTime(tradingAnalytics.lastUpdated),
    fromDate: parseDateTime(tradingAnalytics.fromDate),
  };
}
